import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { AdminProvider } from './contexts/AdminContext';
import Navigation from './components/Navigation';
import EmailVerificationNotice from './components/EmailVerificationNotice';
import LoadingSpinner from './components/LoadingSpinner';

// Lazy load route components for better performance
const Homepage = lazy(() => import('./pages/Homepage'));
const StatesList = lazy(() => import('./pages/StatesList'));
const StateCities = lazy(() => import('./pages/StateCities'));
const CityPlaygrounds = lazy(() => import('./pages/CityPlaygrounds'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const ContactUs = lazy(() => import('./pages/ContactUs'));
const Login = lazy(() => import('./components/Login'));
const Signup = lazy(() => import('./components/Signup'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const AdminListings = lazy(() => import('./pages/AdminListings'));
const AdminInbox = lazy(() => import('./pages/AdminInbox'));
const NotFound = lazy(() => import('./pages/NotFound'));

const AppContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: #2d3436;
`;

function App() {
  return (
    <HelmetProvider>
      <AppContainer>
        <Router>
          <AuthProvider>
            <AdminProvider>
              <Navigation />
              <EmailVerificationNotice />
              <Suspense fallback={<LoadingSpinner />}>
                <Routes>
                  <Route path="/" element={<Homepage />} />
                  <Route path="/states" element={<StatesList />} />
                  <Route path="/state/:stateName" element={<StateCities />} />
                  <Route path="/playgrounds/:stateName/:cityName" element={<CityPlaygrounds />} />
                  <Route path="/about" element={<AboutUs />} />
                  <Route path="/contact" element={<ContactUs />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<Signup />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/admin/listings" element={<AdminListings />} />
                  <Route path="/admin/inbox" element={<AdminInbox />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
            </AdminProvider>
          </AuthProvider>
        </Router>
      </AppContainer>
    </HelmetProvider>
  );
}

export default App;